import { React } from "react";
import PropTypes from "prop-types";
import Icon, { IconTypes } from "../../../../common/Icon";

function CourseLandingPageDetails({ title, datesDisplay, dayTimeDisplay, applyByDate, courseImageURL }) {
  return (
    <div className="CourseLandingPage-details container-content">
      <div className="container-width-controller">
        <div className="container-details">
          <div className="container-heading">
            { title === "Rediscovering Advent" ? <h2>Series Details</h2> : <h2>Course Details</h2> }
            <hr/>
          </div>
          <div className="container-info">
            <div className="dates-row">
              <Icon type={IconTypes.ArrowForward} className="details-icon" />
              <div className="container-text">
                <div className="details-text">{datesDisplay}</div>
                <p>{dayTimeDisplay}</p>
              </div>
            </div>
            <div className="dates-row">
              <Icon type={IconTypes.ArrowForward} className="details-icon" />
              <div className="container-text">
                { title === "Rediscovering Advent" ? <div className="details-text">Free series offering</div> : <div className="details-text">Free course offering</div> }
              </div>
            </div>
            <div className="dates-row">
              <Icon type={IconTypes.ArrowForward} className="details-icon" />
              <div className="container-text">
                <div className="details-text">Apply by {applyByDate}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-image">
          <img src={courseImageURL} alt={title} />
        </div>
      </div>
    </div>
  )
}

CourseLandingPageDetails.propTypes = {
  title: PropTypes.string,
  datesDisplay: PropTypes.string,
  dayTimeDisplay: PropTypes.string,
  applyByDate: PropTypes.string,
  courseImageURL: PropTypes.string
};

export default CourseLandingPageDetails;